import React from "react";
import { useDispatch } from "react-redux";

import { Button } from "components";
import { NotesTable, NoteServiceContext } from "components/tables/notes";
import { uiActions } from "store";

type DealNotesProps = {
	entityId: string;
	brandingColor?: boolean;
	service: any;
	queryKey: string;
	className?: string;
	contentStyle?: React.CSSProperties;
};

const DealNotes = ({
	entityId,
	brandingColor = false,
	service,
	queryKey,
	className,
	contentStyle,
}: DealNotesProps) => {
	const dispatch = useDispatch();

	const handleAddNote = ({ addNote }) => {
		dispatch(
			uiActions.showModal("NOTE_FORM", {
				title: "Add Deal Note",
				brandingColor,
				addNote(note) {
					return addNote({ entityId, note });
				},
			}),
		);
	};

	const handleViewNote = ({ note }) => {
		dispatch(
			uiActions.showModal("NOTE_LIST", {
				title: "View Deal Note",
				brandingColor,
				notes: [note],
			}),
		);
	};

	const handleEditNote = ({ note, editNote }) => {
		const { isRiskNote } = note;
		dispatch(
			uiActions.showModal("NOTE_FORM", {
				title: isRiskNote ? "Edit Risk Note" : "Edit Deal Note",
				note,
				showDiff: true,
				isHideViewPrivatesNotes: isRiskNote,
				brandingColor,
				editNote(updatedNote) {
					return editNote({
						entityId,
						note: updatedNote,
					});
				},
			}),
		);
	};

	const handleDeleteNote = ({ note, deleteNote }) => {
		dispatch(
			uiActions.showModal("CONFIRMATION", {
				title: "Are you sure you want to delete the note?",
				onConfirm() {
					return deleteNote({ entityId, note });
				},
			}),
		);
	};

	return (
		<div>
			<NoteServiceContext.Provider
				value={{
					key: queryKey,
					service,
				}}
			>
				<NotesTable
					entityId={entityId}
					onViewNote={handleViewNote}
					onEditNote={handleEditNote}
					onDeleteNote={handleDeleteNote}
					AddNoteButton={({ addNote }) => (
						<Button
							onClick={() => handleAddNote({ addNote })}
							value="Add Note"
						/>
					)}
					className={className}
					contentStyle={contentStyle}
				/>
			</NoteServiceContext.Provider>
		</div>
	);
};

export default DealNotes;
